var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.914 13.14l5.656-5.656L19 8.914 11.915 16l-.005-.005L5 9.085l1.43-1.43 5.484 5.485z",
    fill: "#25241D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS45MTQgMTMuMTQwNEwxNy41NyA3LjQ4NDM3TDE5IDguOTE0MzRMMTEuOTE0NiAxNS45OTk3TDExLjkxIDE1Ljk5NTFMNC45OTk2NyA5LjA4NTU4TDYuNDI5NDUgNy42NTU4TDExLjkxNCAxMy4xNDA0WiIgZmlsbD0iIzI1MjQxRCIvPgo8L3N2Zz4K";
export { SvgChevron as ReactComponent };